import React from 'react';

const DataManagementSalesTeamPage = () => {
  return (
    <div>
      {/* Article Header */}
      <section
        className="h-[42vh] sm:h-[49vh] md:h-[56vh] bg-cover bg-center bg-no-repeat relative"
        style={{
          backgroundImage: "url('/images/LJM-Blog-Images-10.webp')"
        }}
      >
        {/* Overlay */}
        <div
          className="absolute inset-0"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
        />

        {/* Banner Content */}
        <div className="relative z-10 flex items-center h-full px-4 sm:px-8 md:px-16 lg:px-24">
          <div className="text-center text-white max-w-4xl mx-auto">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-normal mb-4 sm:mb-6 leading-tight text-white">
              Optimise your sales team's<br />
              performance with good data management
            </h1>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <section className="py-8 sm:py-10 md:py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="blog_inner">
            <div className="blog_lift_sidebar">
              <div className="blog_items">
                <div className="prose prose-lg max-w-none">
                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Sales teams today have more data to process than ever before. With lead generation activities on the rise, the amount of data received can be overwhelming.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Our team at <a href="/data-consultancy" className="text-pink-600 hover:text-pink-700 underline">Lloyd James</a> are specialists in data management, and over the years have honed their skills in delivering customer insight which drives performance and growth.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Data influences the day to day running of any company and can help a business accomplish goals, gain more customers and increase revenue. In our opinion a data management process should be in place to optimize your company's marketing efforts, make business decisions based on correct data, reduce operational costs, and finally improve team productivity which in turn drives sales.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    In order to keep up businesses must adapt. Beyond simply gathering data, sales teams must effectively organise and analyse data to make it successful in their lead generation campaigns. Only then can they gain a competitive advantage.
                  </p>

                  <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                    <strong>Why data management in sales is important, what sales data to track, and how to create a data-driven sales team.</strong>
                  </h2>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Recent developments in technology and how sales data is used means that intuition no longer sits in the driver's seat. Data has taken the wheel, and for good reason.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Senior management within businesses need to make major sales decisions in response to market changes, competitor activity and customer preferences. As the cost of lead generation continues to rise, sales efforts need to be focused to preserve resources.
                  </p>

                  <h5 className="text-lg font-semibold text-gray-900 mb-3">
                    <strong>Saves time</strong>
                  </h5>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    An important resource in business is time. A recent survey shows that a large number of sales reps feel that they spend too much time trying to find the right person to contact, resulting in wasted time and resources.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    With properly-maintained data, your sales reps will make the most of their time and optimise their capacity to close out more sales for your business.
                  </p>

                  <h5 className="text-lg font-semibold text-gray-900 mb-3">
                    <strong>Focus</strong>
                  </h5>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    If your sales team's time is spent updating, organizing or correcting data and attempting to contact people using incorrect information, then you are wasting considerable time and resources. From recruitment and hiring, to onboarding and training, a lot of time and money goes into building a successful sales team. If all of their time is used cleaning and managing data then it will take a significantly longer time for your business to achieve a high ROI.
                  </p>

                  <h5 className="text-lg font-semibold text-gray-900 mb-3">
                    <strong>Research</strong>
                  </h5>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    To get to the hard-to-find industry data that your sales team needs, you should start by improving your research. Our experienced data team at <a href="/evidence" className="text-pink-600 hover:text-pink-700 underline">Lloyd James</a> can help with sourcing the right data, we start broad, then dive into the specifics, and we know how to recognise a good quality, verified, data source.
                  </p>

                  <h5 className="text-lg font-semibold text-gray-900 mb-3">
                    <strong>Quality audit</strong>
                  </h5>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Including a quality audit in your data gathering and management process should also be a priority, as this ensures data passed on to your sales team will be relevant, accurate and useful in generating leads. With a sales-ready database, the team's acquisition success rate will improve and ultimately increase overall revenue.
                  </p>

                  <h3 className="text-xl font-semibold text-gray-900 mb-4"><strong>Conclusion</strong></h3>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Sales operations and databases are an integral part of any organisation looking to grow. By investing in the right data management practices, sales teams can align their operations for better performance.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    If your sales team has yet to create a roadmap for data management practices, it's high time to do so. Let an <a href="https://delegate.team/contact/" target="_blank" rel="noreferrer noopener" className="text-pink-600 hover:text-pink-700 underline">expert in data management</a> give you insights into how to improve your strategies for an enhanced sales process.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DataManagementSalesTeamPage;